import { CustomerModelType } from '@teinor/erp/types/company/customer'
import { ProductSupplierModelType } from '@teinor/erp/types/company/product/productSupplier'
import { TitleSButtonPermissioned } from '../../../../../../../../../../baseComponents/Layout/TitleAndRightLayout'
import { TwinSimpleTable } from '../../../../../../../../../../baseComponents/TwinTable'
import { CustomRenderBoolean, CustomRenderPrice, CustomRenderString } from '../../../../../../../../../../baseComponents/TwinTable/VirtualTableListing/CustomRenders'
import { ColumnTableSchema } from '../../../../../../../../../../baseComponents/TwinTable/VirtualTableListing/Subcomponents/types'
import useTwinTranslation from '../../../../../../../../../../utils/hooks/useTwinTranslation'

interface SuppliersProductQuoteTabProps  {
    basicData: CustomerModelType
}

const SuppliersProductQuoteTab: React.FC<SuppliersProductQuoteTabProps> = ({ basicData }) => {
    const { t } = useTwinTranslation()
    const columns: ColumnTableSchema<ProductSupplierModelType> = [
        {
            id: 'SupplierId',
            dataKey: 'SupplierId',
            label: t('supplierId', 'Id del Proveedor'),
            minWidth: 150,
            sortable: true,
            customRender: (parameterValue, allRowData) => <CustomRenderString value={allRowData?.Supplier?.name} />
        },
        {
            id: 'supplier_reference',
            dataKey: 'supplier_reference',
            label: t('supplierRefShort', 'Ref. Prov.'),
            simpleLabel: t('supplierRefLong', 'Referencia Proveedor'),
            toolTip: t('supplierRefLong', 'Referencia Proveedor'),
            minWidth: 170,
            sortable: true,
            searchableComponent: {
                component: 'SearchableComponentBasic',
                extraComponentData: { label: t('supplierReference', 'Referencia del proveedor'), }
            }
        },
        {
            id: 'delivery_time',
            dataKey: 'delivery_time',
            label: t('deliveryTime', 'Tiempo de entrega'),
        },
        {
            id: 'last_price',
            dataKey: 'last_price',
            label: t('lastPrice', 'Último precio'),
            customRender: (parameterValue, allRowData) => <CustomRenderPrice value={parameterValue} {...{ allRowData }} />
        },
        {
            id: 'default_supplier',
            dataKey: 'default_supplier',
            label: t('defaultSupplier', 'Proveedor por defecto'),
            customRender: (parameterValue) => <CustomRenderBoolean value={String(parameterValue) === 'true'} width={143} />
        }
    ]
    return (
        <TitleSButtonPermissioned title={t('productSuppliers', 'Proveedores de Producto')} buttonText={t('save', 'Guardar')} userPermissions={{n: 1, permission: 'read'}} permission='update'>
            <TwinSimpleTable columns={columns} name='productSuppliers' getDataFrom='/api/app/product/productSupplier/getAllProductSuppliersComplete' defaultOrder={{ order: 'desc', defaultOrderField: 'SupplierId' }} extraWhereParams={{ ProductId: basicData?.id }} />
        </TitleSButtonPermissioned>
    )
}

export default SuppliersProductQuoteTab